// extracted by mini-css-extract-plugin
export default {"SalaryRange":"salary-range_SalaryRange__hdBPh"};